import type { Chart } from 'features/trend-detection/types'

export function transformChartToTimeseries(
  chart: Chart,
): { date: string; value: number }[] {
  return chart.data
    .map((item) => ({
      date: String(item.category[0] ?? ''),
      value: item.values[0] ?? 0,
    }))
    .filter((d) => d.date !== '')
}

export function computeShareTimeseries(
  issueChart: Chart,
  projectTotalChart: Chart,
): { date: string; value: number }[] {
  const issuePoints = transformChartToTimeseries(issueChart)
  const projectPoints = transformChartToTimeseries(projectTotalChart)
  const projectByDate = new Map(projectPoints.map((p) => [p.date, p.value]))
  return issuePoints.map((p) => {
    const total = projectByDate.get(p.date) ?? 0
    return { date: p.date, value: total > 0 ? p.value / total : 0 }
  })
}

export function formatMultiplierText(
  multiplier: number | null | undefined,
  recordCount?: number,
  zeroLabel = 'New mentions detected',
): {
  primary: string
  secondary: string
} {
  const primary =
    recordCount != null && recordCount > 0
      ? `${recordCount} ${recordCount === 1 ? 'record' : 'records'}`
      : zeroLabel

  if (
    multiplier === undefined ||
    multiplier === null ||
    !isFinite(multiplier)
  ) {
    return { primary, secondary: 'no prior baseline activity' }
  }

  const pct = (multiplier - 1) * 100
  if (pct > 0) {
    return {
      primary,
      secondary: `${pct.toFixed(0)}% above pre-issue baseline`,
    }
  }
  if (pct < 0) {
    return {
      primary,
      secondary: `${Math.abs(pct).toFixed(0)}% below pre-issue baseline`,
    }
  }
  return { primary, secondary: 'at pre-issue baseline' }
}
